const CODE_BHM = {
  TEXT: {
    B: 'BROUILLARD',
    H: 'HISTORISE',
    M: 'MODELE',
  },
  VALUE: {
    BROUILLARD: 'B',
    HISTORISE: 'H',
    MODELE: 'M',
  },
} as const;

export default CODE_BHM;
